<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!--    <pre>wan: {{device.config.network.interface.wan.proto}} </pre> -->
        <b-row>
            <b-col sm=8>
                <b-card border-variant="light">
                    <div slot="header">
                        <!-- <strong>WAN: (External Network){{this.params.network.device.lan_dev.name}}  </strong> -->
                    </div>
                    <div>
                        <div>
                            <div>
                                <b-form @submit.stop.prevent="onSubmit">
                                    <b-form-group label="Connection Protocol:" label-for="wan0_0_proto" v-if="1 > -1">
                                        <b-form-select key="WAN Protocol" v-model="device.config.network.interface.wan.proto" :options="protoOptions" v-validate="'required'" data-vv-validate-on="change" @change="hack1(device.wan0_0_proto)" id="wan0_0_proto" name="WAN Protocol" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Protocol')}" :readonly=!readonly>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group label="IP Address:" label-for="wan0_0_ipaddr" v-if="device.config.network.interface.wan.proto =='static'">
                                        <b-form-input type="text" key="WAN IP Address" v-model="device.config.network.interface.wan.ipaddr" v-validate.initial="'required|ip'" id="wan0_0_ipaddr" :state="validateState('wan0_0_ipaddr')" name="WAN IP Address" class="form-control" :readonly=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN IP Address')" class="invalid-feedback">{{ errors.first('WAN IP Address') }}</div>
                                    </b-form-group>

                                    <b-form-group label="Netmask:" label-for="wan0_0_ipaddr" v-if="device.config.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN Netmask" v-model="device.config.network.interface.wan.netmask" v-validate.initial="'required|ip'" id="wan0_0_netmask" name="WAN Netmask" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Netmask')}" :readonly=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN Netmask')" class="invalid-feedback">{{ errors.first('WAN Netmask') }}</div>
                                    </b-form-group>

                                    <b-form-group label="Gateway:" label-for="wan0_0_gateway" v-if="device.config.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN Gateway" v-model="device.config.network.interface.wan.gateway" v-validate.initial="'required|ip'" id="wan0_0_gateway" name="WAN Gateway" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN Gateway') }" :readonly=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN Gateway')" class="invalid-feedback">{{ errors.first('WAN Gateway') }}</div>
                                    </b-form-group>

                                    <b-form-group label="DNS Server:" label-for="wan0_0_dns" v-if="device.config.network.interface.wan.proto === 'static'">
                                        <b-form-input type="text" key="WAN DNS Server" v-model="device.config.network.interface.wan.dns" v-validate.initial="'required|ip'" id="wan0_0_dns" name="WAN DNS Server" class="form-control" :class="{'is-invalid': submitted && verrors.has('WAN DNS Server') }" :readonly=!readonly>
                                        </b-form-input>
                                        <div v-if="submitted && verrors.has('WAN DNS server')" class="invalid-feedback">{{ errors.first('WAN DNS Server') }}</div>
                                    </b-form-group>

                                    <b-form-group label="PPPoE Username:" label-for="wan0_0_username" v-if="device.config.network.interface.wan.proto =='pppoe'">
                                        <b-form-input type="text" key="PPPoE Username" v-model="device.config.network.interface.wan.username" v-validate="'required'" id="wan0_0_username" name="PPPoE Username" class="form-control" :class="{'is-invalid': submitted && verrors.has('PPPoE Username') }" :readonly=!readonly></b-form-input>
                                        <div v-if="submitted && verrors.has('PPPoE Username')" class="invalid-feedback">{{ errors.first('PPPoE Username') }}</div>
                                    </b-form-group>
                                    <b-form-group label="PPPoE Password:" label-for="wan0_0_password" v-if="device.config.network.interface.wan.proto =='pppoe'">
                                        <b-form-input type="text" key="PPPoE Password" v-model="device.config.network.interface.wan.password" v-validate="'required'" id="wan0_0_password" name="PPPoE Password" class="form-control" :class="{'is-invalid': submitted && verrors.has('PPPoE Password') }" :readonly=!readonly></b-form-input>
                                        <div v-if="submitted && verrors.has('PPPoE Password')" class="invalid-feedback">{{ errors.first('PPPoE Password') }}</div>
                                    </b-form-group>

                                    <div class="text-center">
                                        <!-- TODO only activate when dirty -->
                                        <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save</button>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col sm=4>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>Tasks</strong>
                    </div>
                    <Tasks :device="device" :changed="changed" :changes="changes"></Tasks>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/devices/network/Tasks";
import IPaddress from 'ip-address';

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
        IPaddress,
    },

    props: {
        device: {
            type: Object,
            default: function () {
                return {}
            }
        },
        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },
    created() {
        this.proto_value = this.device.config.network.interface.wan.proto;

    },

    data() {
        return {
            loading: false,
            submitted: false,
            protoOptions: [
                { text: 'DHCP', value: "dhcp" },
                { text: 'Static', value: "static" },
                { text: 'PPPoE', value: "pppoe" },
            ],
            proto_flag: false,
            proto_value: '',
        }
    },

    methods: {

        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },

        hack1: function (value) {
            if (!this.proto_flag) {
                this.proto_value = value;
                this.proto_flag = true;
            }
        },
        mounted() {},
        updateChanged(par, val, nam) {
            // if proto is static => unload pppoe params
            // if proto is pppoe unload static params
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this

                    // if (this.proto_value != this.device.wan0_0_proto && this.proto_flag) {
                    //   this.updateChanged("wan0_0_proto", this.device.wan0_0_proto, "WAN Protocol")
                    // } else if (this.proto_flag) {
                    //   this.updateChanged("wan0_0_proto", this.proto_value, "WAN Protocol")
                    // }

                    if (this.veeFields['WAN Protocol'].dirty) {
                        this.updateChanged("wan0_0_proto", this.device.config.network.interface.wan.proto, "WAN Protocol")
                    }

                    if (this.device.config.network.interface.wan.proto == "static") {
                        if (this.veeFields['WAN IP Address'].dirty) {
                            this.updateChanged("wan0_0_ipaddr", this.device.config.network.interface.wan.ipaddr, "WAN IP Address")
                            // var Address4 = require('ip-address').Address4;
                            // var myip = new Address4(this.device.config.network.interface.wan.ipaddr);
                            // if(myip.isValid)
                            //   console.log('Valid' );

                        }
                        if (this.veeFields['WAN Netmask'].dirty) {
                            this.updateChanged("wan0_0_netmask", this.device.config.network.interface.wan.netmask, "WAN Netmask")
                        }
                        if (this.veeFields['WAN Gateway'].dirty) {
                            this.updateChanged("wan0_0_gateway", this.device.config.network.interface.wan.gateway, "WAN Gateway")
                        }
                        if (this.veeFields['WAN DNS Server'].dirty) {
                            this.updateChanged("wan0_0_dns", this.device.config.network.interface.wan.dns, "WAN DNS Server")
                        }
                    } else if (this.device.config.network.interface.wan.proto == "pppoe") {

                        if (this.veeFields['PPPoE Username'].dirty) {
                            this.updateChanged("wan0_0_username", this.device.config.network.interface.wan.username, "PPPoE Username")
                        }
                        if (this.veeFields['PPPoE Password'].dirty) {
                            this.updateChanged("wan0_0_password", this.device.config.network.interface.wan.password, "PPPoE Password")
                        }
                    }

                    // this.$router.push("/#/devices");
                } else {
                    console.log("WAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('device','edit')
        }
    },
};
</script>
